import { TYPES } from "../actions/componentsAction.js";

const {
  API_REQUEST,
  API_ERROR,
  API_SUCCESS,

  CREATE_RC_SUCCESS,
  LIST_RC_SUCCESS,
  DELETE_RC_SUCCESS,
  UPDATE_RC_SUCCESS,
  SHARED_RC_SUCCESS,

  USER_LIST,
  //Added for changing user role and status
  UPDATE_USER,
  CLEAR_ERROR
} = TYPES;

const initialState = {
  loading: false,
  componentError: "",
  components: [],
  users: []
};

const componentReducer = (state = initialState, action) => {
  switch (action.type) {
    case API_REQUEST: {
      return { ...state, loading: true };
    }

    case API_ERROR: {
      return {
        ...state,
        componentError: action.payload,
        loading: false
      };
    }

    case API_SUCCESS: {
      return { ...state, loading: false }
    }

    case CREATE_RC_SUCCESS: {
      return {
        ...state,
        components: [
          { ...action.payload, isUserCreator: true },
          ...state.components
        ],
        loading: false
      };
    }

    case LIST_RC_SUCCESS: {
      return {
        ...state,
        components: action.payload,
        loading: false
      };
    }

    case SHARED_RC_SUCCESS:
      const allRcs = [...state.components];
      const newRcs = allRcs.map((rc) =>
        rc._id === action.data.rcId ? { ...rc, sharedWith: action.data.sharedWithData } : rc
      );
      return {
        ...state,
        components: newRcs,
        loading: false
      };

    case UPDATE_RC_SUCCESS: {
      const allRC = [...state.components];
      const newRC = allRC.map(((rc) => (
        rc._id === action.payload.rcId ? { ...rc, name: action.payload.name }
          : rc
      )));

      return {
        ...state,
        components: newRC,
        loading: false
      };
    }

    case DELETE_RC_SUCCESS: {
      const components = [...state.components];
      return {
        ...state,
        components: components.filter(
          (rc) => rc._id !== action.payload
        ),
        loading: false
      };
    }

    case USER_LIST: {
      return {
        ...state,
        loading: false,
        users: action.data,
        //Added for changing user role and status
        allRoles: action.allRoles
      };
    }

    //Added for changing user role and status
    case UPDATE_USER: {
      const allRC = [...state.users];
      const newRC = allRC.map(((rc) => (
        rc._id === action.payload.rcId ? { ...rc, role: action.payload.role, isActive: action.payload.isActive }
          : rc
      )));
      return {
        ...state,
        components: newRC,
        loading: false,
        msg: "User updated successfully!"
      };
    }

    case CLEAR_ERROR:
      return {
        ...state,
        error: false,
        msg: null
      }

    default: {
      return { ...state };
    }
  }
};

export default componentReducer;